import React from 'react';
import {Settings} from "../../../Settings/Settings";

export default function BalanceInfo(props) {
    return <div>
        The full payment of {Settings.currencyFormatter.format(props.booking.value)} is required to secure this
        booking
    </div>
}